// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"19a9040e","374":"10d07c50"}[chunkId] + ".chunk.css";
};